var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2B2826"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.20002,
    y: -5.19999,
    width: 48.4,
    height: 46.4
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.4px)",
      clipPath: "url(#bgblur_0_11072_82371_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11072_82371)",
    "data-figma-bg-blur-radius": 12.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6866 18.5C25.6135 18.5 24.5443 18.2295 23.5979 17.733C23.4387 17.6495 23.248 17.6495 23.0887 17.733C22.1423 18.2295 21.0731 18.5 20 18.5C18.9268 18.5 17.8576 18.2295 16.9113 17.733C16.752 17.6495 16.5613 17.6495 16.402 17.733C15.4557 18.2295 14.3865 18.5 13.3133 18.5C12.4369 18.5 11.5719 18.3251 10.7758 17.9972C10.4201 17.8507 10 18.0966 10 18.4812V24C10 26.2092 11.7909 28 14 28H26C28.2091 28 30 26.2092 30 24V18.4812C30 18.0965 29.5799 17.8507 29.2242 17.9972C28.428 18.3251 27.5631 18.5 26.6866 18.5ZM23 26V24C23 22.3432 21.6569 21 20 21C18.3431 21 17 22.3432 17 24V26H23Z",
    fill: "url(#paint0_linear_11072_82371)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1292 8C11.3295 8 10.6066 8.47587 10.2908 9.21017L9.28979 11.5378C9.09764 11.9846 8.89694 12.6326 9.05991 13.3375C9.49336 15.2121 11.2929 16.5 13.31 16.5C14.6147 16.5 15.8402 15.9534 16.655 15.0576C17.4698 15.9534 18.6953 16.5 20 16.5C21.3047 16.5 22.5302 15.9534 23.345 15.0576C24.1598 15.9534 25.3853 16.5 26.69 16.5C28.7071 16.5 30.5066 15.2121 30.9401 13.3375C31.1031 12.6326 30.9024 11.9846 30.7102 11.5378L29.7092 9.21017C29.3934 8.47587 28.6705 8 27.8708 8H12.1292Z",
    fill: "url(#paint1_linear_11072_82371)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9961 17.5557C23.2133 17.4418 23.4732 17.4419 23.6904 17.5557C24.6088 18.0375 25.6466 18.2998 26.6865 18.2998C27.5365 18.2998 28.3761 18.1306 29.1484 17.8125C29.6168 17.6198 30.2002 17.9347 30.2002 18.4814V24C30.2002 26.3196 28.3196 28.2002 26 28.2002H14C11.6804 28.2002 9.7998 26.3196 9.7998 24V18.4814C9.7998 17.9347 10.3832 17.6198 10.8516 17.8125C11.6239 18.1306 12.4635 18.2998 13.3135 18.2998C14.3534 18.2998 15.3912 18.0375 16.3096 17.5557C16.5268 17.4419 16.7867 17.4418 17.0039 17.5557C17.9223 18.0375 18.96 18.2998 20 18.2998C21.04 18.2998 22.0777 18.0375 22.9961 17.5557ZM20 21.2002C18.4536 21.2002 17.2002 22.4536 17.2002 24V25.7998H22.7998V24C22.7998 22.4536 21.5464 21.2002 20 21.2002ZM27.8711 7.7998C28.7504 7.79992 29.5451 8.3234 29.8926 9.13086L30.8936 11.459C31.0919 11.9203 31.312 12.6164 31.1348 13.3828C30.6774 15.36 28.7873 16.7 26.6904 16.7002C25.4072 16.7002 24.1948 16.1923 23.3447 15.3457C22.4947 16.1921 21.2831 16.7002 20 16.7002C18.7166 16.7002 17.5044 16.1924 16.6543 15.3457C15.8043 16.192 14.5926 16.7002 13.3096 16.7002C11.2127 16.7 9.32257 15.36 8.86523 13.3828C8.68802 12.6164 8.90806 11.9203 9.10645 11.459L10.1074 9.13086C10.4549 8.3234 11.2496 7.79992 12.1289 7.7998H27.8711Z",
    stroke: "#C58000",
    strokeOpacity: 0.48,
    strokeWidth: 0.4,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11072_82371",
    x: -4.20002,
    y: -5.19999,
    width: 48.4,
    height: 46.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.899346 0 0 0 0 0.713726 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11072_82371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11072_82371",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11072_82371_clip_path",
    transform: "translate(4.20002 5.19999)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6866 18.5C25.6135 18.5 24.5443 18.2295 23.5979 17.733C23.4387 17.6495 23.248 17.6495 23.0887 17.733C22.1423 18.2295 21.0731 18.5 20 18.5C18.9268 18.5 17.8576 18.2295 16.9113 17.733C16.752 17.6495 16.5613 17.6495 16.402 17.733C15.4557 18.2295 14.3865 18.5 13.3133 18.5C12.4369 18.5 11.5719 18.3251 10.7758 17.9972C10.4201 17.8507 10 18.0966 10 18.4812V24C10 26.2092 11.7909 28 14 28H26C28.2091 28 30 26.2092 30 24V18.4812C30 18.0965 29.5799 17.8507 29.2242 17.9972C28.428 18.3251 27.5631 18.5 26.6866 18.5ZM23 26V24C23 22.3432 21.6569 21 20 21C18.3431 21 17 22.3432 17 24V26H23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1292 8C11.3295 8 10.6066 8.47587 10.2908 9.21017L9.28979 11.5378C9.09764 11.9846 8.89694 12.6326 9.05991 13.3375C9.49336 15.2121 11.2929 16.5 13.31 16.5C14.6147 16.5 15.8402 15.9534 16.655 15.0576C17.4698 15.9534 18.6953 16.5 20 16.5C21.3047 16.5 22.5302 15.9534 23.345 15.0576C24.1598 15.9534 25.3853 16.5 26.69 16.5C28.7071 16.5 30.5066 15.2121 30.9401 13.3375C31.1031 12.6326 30.9024 11.9846 30.7102 11.5378L29.7092 9.21017C29.3934 8.47587 28.6705 8 27.8708 8H12.1292Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11072_82371",
    x1: 20,
    y1: 20.0042,
    x2: 20,
    y2: 25.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11072_82371",
    x1: 20,
    y1: 20.0042,
    x2: 20,
    y2: 25.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.6dc7560790ee1105f3eba039331b89f1.svg";
export { ForwardRef as ReactComponent };